import { render, staticRenderFns } from "./argumentLink.vue?vue&type=template&id=78a50e3f&scoped=true"
import script from "./argumentLink.vue?vue&type=script&lang=js"
export * from "./argumentLink.vue?vue&type=script&lang=js"
import style0 from "./argumentLink.vue?vue&type=style&index=0&id=78a50e3f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a50e3f",
  null
  
)

export default component.exports